<div *ngIf="pageLoading" class="loader text-center">
	<img src="../../assets/img/loading.gif" style="width: 100px;" />
	<p style="color: black;font-weight: bolder;">Loading...</p>
</div>
@if (navbar.userAccess?.Medicine_Master=='Full') {
<form class="row g-3" [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm">
	<div class="row mb-3">
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('name')}" id="name"
					formControlName="name" placeholder="">
				<label for="name">Name*</label>
			</div>
			<p *ngIf="showError('name')" class="text-danger">
				<span *ngIf="f.name.errors?.required">
					Required
				</span>
				<span *ngIf="f.name.errors?.incorrect">
					{{customError.name}}
				</span>
			</p>
		</div>
		<div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
			<div class="form-floating">
				<textarea class="form-control" [ngClass]="{'is-invalid':showError('ingredients')}" id="ingredients"
					formControlName="ingredients" placeholder=""></textarea>
				<label for="ingredients">Description*</label>
			</div>
			<p *ngIf="showError('ingredients')" class="text-danger">
				<span *ngIf="f.ingredients.errors?.required">
					Required
				</span>
				<span *ngIf="f.ingredients.errors?.incorrect">
					{{customError.ingredients}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-3">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<button type="submit" class="btn btn-sm btn-primary me-1">
				<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
				<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
				Submit
			</button>
			<button type="button" class="btn btn-sm btn-secondary" (click)="clearForm();">Cancel</button>
		</div>
	</div>
</form>
}@else {
<div>
	<h3 class="text-center">You don't have access to this section.</h3>
</div>
}